import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Table } from "react-bootstrap";
import "./styles.css";
import * as XLSX from "xlsx";
import SearchableSelect from "./components/SearchableSelect";
import logo from "./logo1.png";

import {API_BASE_URL} from "./config"
const RapportFacing = () => {
  const [date, setDate] = useState("");
  const [userId, setUserId] = useState("");
  const [rapports, setRapports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [workers, setWorkers] = useState([]);

  const fetchWorkers = useCallback(async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}Merchandiser/GetMerchandisers`
      );
      setWorkers(response.data);
    } catch (error) {
      console.error("Error fetching workers:", error);
    }
  }, []);

  useEffect(() => {
    fetchWorkers();
  }, [fetchWorkers]);

  const fetchRapports = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}Rapporting/GetRapportFacing`,
        {
          params: {
            date: date,
            user_id: userId,
          },
        }
      );
      console.log("Rapports response:", response.data);
      // Transform image paths to full URLs
      const transformedRapports = response.data.map(rapport => ({
        ...rapport,
        images: rapport.images.map(image => ({
          ...image,
          imgPath: `${API_BASE_URL.replace("/api","/AppImages/FacingPhotos")}/${image.imgPath}`}))
      }));
      setRapports(transformedRapports);
    } catch (error) {
      console.error("Error fetching rapports:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRapports();
  }, [date,userId]);


  const handlePrint = () => {
    window.print();
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      rapports.map((rapport) => ({
        ...rapport,
        imgAvant: rapport.imgAvant || "N/A",
        imgApres: rapport.imgApres || "N/A",
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Rapport Facing");
    XLSX.writeFile(workbook, "Rapports.xlsx");
  };

  return (
    <div style={styles.container}>
                        {/* Print Header - Only visible when printing */}
      <div className="print-header no-print"> 
        <img src={logo} alt="Logo" className="print-logo" /> 
        <div className="print-title">Rapport Facing</div> 
      </div>
      <h2 className="no-print" style={styles.header}>Rapport Facing</h2>
      <div className="no-print">
        <div style={styles.formContainer} className="no-print">
          <div style={styles.formGroup}>
            <label style={styles.label}>Date:</label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              style={styles.input}
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Marchandiseur:</label>
            <SearchableSelect
              options={workers}
              value={userId}
              onChange={setUserId}
              placeholder="Sélectionner Marchandiseur"
            />
          </div>
          <button onClick={handlePrint} style={styles.button}>
            <i className="bi bi-printer"></i>
          </button>
          <button onClick={exportToExcel} style={styles.button}>
            Exporter
            <i className="bi bi-file-earmark-spreadsheet"></i>
          </button>
        </div>
      </div>

      {loading ? (
        <p style={styles.loading}>Chargement...</p>
      ) : rapports.length === 0 ? (
        <p style={styles.empty}>Aucun rapport à afficher.</p>
      ) : (

      <div>
        {rapports.map((report, reportIndex) => (
          <div style={{ textAlign: 'center' }} key={reportIndex}>
            <h4>
              {report.missionDate}<br />
              {report.raisonSocial}<br />
              {report.adresse}<br />
              {report.userName}
            </h4>
            <div style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
              <div className="additional-info">
                <p>
                {report.datePointage && (
                 <span> <strong>Date Pointage:</strong> {report.datePointage}</span>
                )}
                {report.heureArrivee && (
                 <span> <strong>Heure Arrivée:</strong> {report.heureArrivee}</span>  
                )}
                {report.heureDepart && (
                  <span> <strong>Heure Départ:</strong> {report.heureDepart} </span> 
                )}
                </p>
                {report.commentaire && (
                  <p><strong>Observation:</strong> {report.commentaire}</p>
                )}
              </div>
            </div>

              <Table bordered className="custom-table" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
              <thead>
                <tr>
                  <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'center' }}>Gamme</th>
                  <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'center' }}>Avant</th>
                  <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'center' }}>Après</th>
                </tr>
              </thead>
              <tbody>
                {[...new Set(report.images.map(img => img.gamme))].map((gamme, gammeIndex) => {
                  const imagesForGamme = report.images.filter(img => img.gamme === gamme);
                  return (
                    <tr key={gammeIndex}>
                      <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'center', verticalAlign: 'top' }}>
                        {gamme}
                      </td>
                      <td style={{ border: '1px solid #000', padding: '8px' }}>
                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                          {imagesForGamme
                            .filter(img => img.facingType === 'AVANT')
                            .map((image, i) => (
                              <img
                                key={i}
                                src={image.imgPath}
                                alt="Avant"
                                style={{ width: '100px', height: '150px', objectFit: 'contain' }}
                              />
                            ))}
                        </div>
                      </td>
                      <td style={{ border: '1px solid #000', padding: '8px' }}>
                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                          {imagesForGamme
                            .filter(img => img.facingType === 'APRES')
                            .map((image, i) => (
                              <img
                                key={i}
                                src={image.imgPath}
                                alt="Après"
                                style={{ width: '100px', height: '150px', objectFit: 'contain' }}
                              />
                            ))}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

          </div>
        ))}
      </div>
      )};
    </div>
)};

const styles = {
  container: {
    padding: "15px",
    fontFamily: "Arial, sans-serif",
  },
  header: {
    color: "#333",
    marginBottom: "10px",
    textAlign: "center",
  },
  formContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "15px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
    marginRight: "15px",
  },
  label: {
    marginBottom: "5px",
    fontWeight: "bold",
  },
  input: {
    padding: "10px",
    borderRadius: "4px",
    border: "1px solid #ddd",
    width: "195px",
    boxSizing: "border-box",
  },
  button: {
    padding: "10px 20px",
    borderRadius: "4px",
    border: "none",
    backgroundColor: "#d6eaf8",
    fontSize: "16px",
    marginLeft: "10px",
    height: "40px",
    marginTop: "30px",
    alignItems: "center",
  },
  loading: {
    fontSize: "16px",
    color: "#007bff",
    textAlign: "center",
  },
  error: {
    fontSize: "16px",
    color: "red",
    textAlign: "center",
  },
  empty: {
    fontSize: "16px",
    color: "#333",
    textAlign: "center",
  },
  tableContainer: {
    marginBottom: "20px",
  },
};

export default RapportFacing;